module.exports = __webpack_public_path__ + "static/media/room-6.b183c4de.jpg";